import { hocHook } from "../../../@hoc/hoc-hook";
import { Create } from "./create";

export default hocHook(Create);
